import { render, staticRenderFns } from "./AppCardHeader.vue?vue&type=template&id=86b8befa&scoped=true&"
import script from "./AppCardHeader.vue?vue&type=script&lang=js&"
export * from "./AppCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppCardHeader.vue?vue&type=style&index=0&id=86b8befa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b8befa",
  null
  
)

export default component.exports